import styled from "@emotion/styled";

export const StatsPage = styled.div`
  padding: 24px 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: 16px 0;
  }
`;

export const CenterLoader = styled.div`
  min-height: calc(100vh - 160px);
  display: flex;
  align-items: center;
  justify-content: center;
`;
